import { cn } from "@babybjorn/ui";
import type { ElementType, FC, ReactNode } from "react";
import Button from "../../components/general/Button";
import type { ButtonProps } from "../../components/general/Button/Button";
import { useIsTablet } from "../../hooks/use-is-screensize";
import * as s from "./HeroBanner.module.scss";

type HeroBannerProps = {
	title: string;
	label: string;
	backgroundColor?: string;
	media: ReactNode;
	mobileMedia?: ReactNode | null;
	buttonProps?: ButtonProps;
	labelHeadingAs?: ElementType;
	variant: "block" | "gradient";
	inverted?: boolean;
	isInDoubleTextBlock?: boolean; //Applies other ratios, to be used in DoubleTextBlock.
	mobileImageRatio?: "1:1" | "5:7";
};

const HeroBanner: FC<HeroBannerProps> = ({
	title,
	label,
	labelHeadingAs = "h2",
	variant = "block",
	inverted,
	backgroundColor: bgcolor = "#D0C9C4",
	mobileImageRatio = "1:1",
	media,
	mobileMedia,
	buttonProps,
	isInDoubleTextBlock,
}) => {
	const Heading = labelHeadingAs;
	const isTablet = useIsTablet();

	return (
		<section
			className={cn(s.hero, {
				[s.doubleTextBlock]: isInDoubleTextBlock,
				[s.ratio_5_7]: mobileImageRatio === "5:7",
			})}
		>
			{media && (
				<div className={cn(s.backgroundImage)}>
					{!isTablet && mobileMedia ? mobileMedia : media}
				</div>
			)}

			<div
				className={cn(s.overlay, {
					[s.block]: variant === "block",
					[s.gradient]: variant === "gradient",
					[s.inverted]: inverted,
				})}
				style={{
					["--overlay-color" as string]: bgcolor,
				}}
			>
				<header className={s.header}>
					<Heading
						className={cn(s.heading, { [s.hyphens]: title.includes("|") })}
					>
						{title.replaceAll("|", "\u00AD")}
					</Heading>
					<h3 className={s.label}>{label}</h3>
				</header>
				{buttonProps?.label && (
					<Button
						{...buttonProps}
						variant={inverted ? "inverted" : "secondary"}
					/>
				)}
			</div>
		</section>
	);
};

export default HeroBanner;
